import { z } from 'zod';
import { Operator } from '../api/generated';
export const OperatorSchema = z.nativeEnum(Operator);
// probably better to create discriminated union of conditions for each operator
const ConditionWithoutValueSchema = z
    .object({
    field: z.string(),
    operator: z.enum([Operator.Duplicity, Operator.Empty, Operator.NotEmpty]),
})
    .strip();
const ConditionWithValueSchema = z.object({
    field: z.string(),
    operator: z.enum([
        Operator.Equals,
        Operator.NotEquals,
        Operator.Contains,
        Operator.NotContains,
        Operator.StartsWith,
        Operator.LessThan,
        Operator.LessThanOrEqual,
        Operator.GreaterThan,
        Operator.GreaterThanOrEqual,
    ]),
    value: z.union([z.number(), z.string().min(1), z.boolean()]),
});
const ConditionSchema = z.discriminatedUnion('operator', [ConditionWithValueSchema, ConditionWithoutValueSchema]);
const OrConditionsSchema = z.object({
    orConditions: z.array(ConditionSchema),
    fixed: z.boolean().optional(),
});
export const andConditionsSchema = z.object({
    andConditions: z.array(OrConditionsSchema),
});
//# sourceMappingURL=filterSchemas.js.map